var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress_nft"},[_c('h2',[_vm._v("Minting")]),_c('div',{staticClass:"progress_bar"},[_c('div',{staticClass:"current_bar",style:(_vm.progressStyle)}),_c('span',[_vm._v(_vm._s(_vm.phase2)+"/"+_vm._s(_vm.total))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }